export default __webpack_public_path__ + "static/media/TotemUso10.a3503996.jpg";